import React, { useState, useEffect } from 'react';
import { AgGridReact, AgGridColumn } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Select from 'react-select';
import axios from 'axios';
import { Button, Grid, Menu } from 'semantic-ui-react';
import { getvendorcode,getkpidatarecon, Fetchbankinvoicedetails,Fetchexecutequery,Fetchselectivevendordetails,Fetchbankinvoicedetails_1,Fetchselectiveerpinvoicedetails,getBRSReportFromServer, Fetchbankinvoicedetails1 } from '../../../services/process/BRS1/vrsreport';
import * as XLSX from 'xlsx';
import excelIcon from '../../../assets/images/excel.png';
import RenderGrid from './grid';

const VerticalTabsWithAgGrid = () => {
  const [showTabs, setShowTabs] = useState(false);
  const [link, setLink] = useState('');
  const [erpbalance, setErpBalance] = useState(false);
  const [vendorbalance, setVendorBalance] = useState(false);
  const [annexure1diff, setannexure1Balance] = useState(false);
  const [annexure2diff, setannexure2Balance] = useState(false);
  const [annexure3diff, setannexure3Balance] = useState(false);
  const [annexure4diff, setannexure4Balance] = useState(false);
  const [annexure5diff, setannexure5Balance] = useState(false);
  const [annexure6diff, setannexure6Balance] = useState(false);
  const [annexure7diff, setannexure7Balance] = useState(false);
  const [annexure8diff, setannexure8Balance] = useState(false);
  const [annexure9diff, setannexure9Balance] = useState(false);
  const [reportremarks, setReportremarks] = useState(false);
  const [totalcredits, settotalCredit] = useState(false);
  const [totaldebits, settotalDebit] = useState(false);
  const [totalbalan, settotalBal] = useState(false);
  const [venopenamt, setVenopen] = useState(false);
  const [intopenamt, setIntopen] = useState(false);
  const [openvarianceamt, setOpenVariance] = useState(false);
  const [totalvar, settotalVariance] = useState(false);
  const [chek, setCheck] = useState(false);
  const [recper, setReconperiod] = useState(false);  
  const [balancevariance, setVariance] = useState(false);
  const [remarkscol, setremarkscol] = useState([]);
  const [activeTab, setActiveTab] = useState('Summary');
  const [tableData, setTableData] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedOption1, setSelectedOption1] = useState('');
  const [options, setOptions] = useState([]);
  const [division, setDivision] = useState([]);
  const tabNames = ['Summary','Annexure 1', 'Annexure 2','Annexure 3','Annexure 4','Annexure 5','Annexure 6','Annexure 7','Annexure 8','Annexure 9']; 
  const [tabDataMap, setTabDataMap] = useState({});

  useEffect(() => {
    if (showTabs) {
      if (activeTab === 'Summary') {
        getKpiinfo(activeTab);
        fetchDataForAllTabs()
      } else {
        fetchDataForTab(activeTab);
      }
    }
  }, [showTabs, activeTab]);


  const handleSearchClick = () => {
    reportClick();
    setShowTabs(true);
  };

  const handleSelection = (selectedOption) => {
    setSelectedOption(selectedOption ? selectedOption.value : '');
    // Filter divisions based on the selected vendor code
    const filteredDivisions = options.find(opt => opt.value === selectedOption.value)?.divisions || [];
    setDivision(filteredDivisions);
    setSelectedOption1('');
    setShowTabs(false);
  };

  useEffect(() => {
    vrsvendorcode();
  }, []);

  function vrsvendorcode() {
    let payload = {};
    var getProcessingLayerList = getvendorcode();

    axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
      .then(response => {
        let data = response.data;
        if (data) {
          let options = data.map((row) => ({
            label: row.vendor_code,
            value: row.vendor_code,
            clientId: row.clientId,
            divisions: data
              .filter(item => item.vendor_code === row.vendor_code)
              .map(item => ({
                label: item.division,
                value: item.division,
                key: item.vendor_code,
              })),
          }));
          setOptions(options);
          setDivision(options.length > 0 ? options[0].divisions : []);
        }
      })
      .catch(error => {
        console.error("Error in Processing Layer List!!!", error);
      });
  }

  const handleSelection1 = (selectedOption) => {
    setSelectedOption1(selectedOption ? selectedOption.value : '');
  };

  // const handleDownloadExcel = () => {
  //   if (tableData.length > 0) {
  //     const ws = XLSX.utils.json_to_sheet(tableData);
  //     const wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
  //     XLSX.writeFile(wb, "vrs_{selectoption1}.xlsx");
  //   }
  // };

  function reportClick()
  {
      
      let payload = {
          "supplier_code" : selectedOption,
          'division' : selectedOption1
      }

      var getBrsReport = getBRSReportFromServer();

      axios.post(getBrsReport[1], {params : payload}, getBrsReport[0])
      .then(
          response => {
              console.log("Report Generated Response!!!", response)
              let data = response["data"];
              if (data["Status"] === "Success")
              {
                  console.log("data", data);
                  setLink(data["file"]);
                  
              }
              else{
                console.log("Error in File Generated!!!");
                  
              }
          }
      ).catch(
          error => {
              console.log("Error in File Generated!!!", error);
          }
      );

  }

  const summaryItems = [
    { description: 'Closing Balance as per ABS', value: erpbalance },
    { description: 'Closing Balance as per Vendor', value: vendorbalance },
    { description: 'Variance', value: balancevariance },
    { description: 'Reasons for Variance'},
    { description: '1.Sales considered by vendor but not accounted by ABS', value: annexure1diff },
    { description: '2.Invoice raised by supplier in different accounting period, ABS accounted in Current period', value: annexure2diff },
    { description: '3.Payment received by vendor but not accounted by ABS', value: annexure3diff },
    { description: '4.Payment made by ABS not accounted by vendor', value: annexure4diff },
    { description: '5.TDS dedcuted by ABS not accounted by Supplier', value: annexure5diff },
    { description: '6.Debit Note raised by ABS not accounted by Supplier', value: annexure6diff },
    { description: '7.Invoices reconciled with value differences', value: annexure7diff },
    { description: '8.Credit Note raised by Vendor not accounted by ABS', value: annexure8diff },
    { description: '9.Contra entries as per ABS SOA', value: annexure9diff },
    { description: 'Difference in Opening balance of ABS & Vendor statement', value: openvarianceamt },
    { description: 'Opening balance as per ABS', value: intopenamt },
    { description: 'Opening balance as per Vendor', value: venopenamt },
    { description: 'Sum of total variance', value: totalvar },
    { description: 'Check', value: chek },
    { description: 'Reconciliation done till', value: recper },
    // Add more summary items as needed
  ];

  

  const fetchDataForAllTabs = async () => {

    try {
      const tabs = ['Annexure1','Annexure2','Annexure3','Annexure4','Annexure5','Annexure6','Annexure9'];
      const allTabData = {};
      
  
      // Loop through each tab
      for (const tab of tabs) {
        let payload;
        let fetchFunction;

        switch (tab) {
          case 'Annexure1':
            payload = {
              query: `select sum(GL_DEBIT) as debit,sum(GL_CREDIT) as credit, sum(GL_DEBIT - GL_CREDIT) AS difference FROM Vendor_Reconcilation_System.internal_statement where SUPPLIER_CODE = '${selectedOption}' and DIVISION_NAME = '${selectedOption1}' and DOC_CATEGORY = 'STD INV' and status = 'Unmatched'`
            };

            fetchFunction = Fetchexecutequery;

            break;
          case 'Annexure2':
            payload = {
              
                query: `select sum(GL_DEBIT) as debit,sum(GL_CREDIT) as credit, sum(GL_DEBIT - GL_CREDIT) AS difference FROM Vendor_Reconcilation_System.internal_statement where SUPPLIER_CODE = '${selectedOption}' and DIVISION_NAME = '${selectedOption1}' and DOC_CATEGORY like '%BV%' and status = 'Unmatched'`
                       };

            fetchFunction = Fetchexecutequery;
            break;

          case 'Annexure3':
            payload = {
            
              query: `select sum(GL_DEBIT) as debit,sum(GL_CREDIT) as credit, sum(GL_DEBIT - GL_CREDIT) AS difference FROM Vendor_Reconcilation_System.internal_statement where SUPPLIER_CODE = '${selectedOption}' and DIVISION_NAME = '${selectedOption1}' and (DOC_CATEGORY ='CRM INV'OR DOC_CATEGORY LIKE '%TDS%') and status = 'Unmatched'`
            };
            fetchFunction = Fetchexecutequery;
            break;
          case 'Annexure4':
            payload = {
             
                query: `select sum(GL_DEBIT) as debit,sum(GL_CREDIT) as credit, sum(GL_DEBIT - GL_CREDIT) AS difference FROM Vendor_Reconcilation_System.internal_statement where SUPPLIER_CODE = '${selectedOption}' and DIVISION_NAME = '${selectedOption1}' and (DOC_CATEGORY LIKE '%DBM%' OR DOC_CATEGORY LIKE '%DN%') and status = 'Unmatched'`
            };
            fetchFunction = Fetchexecutequery;
            break;
          case 'Annexure5':
            payload = {
              
                query: `select sum(debit) as debit,sum(credit) as credit, sum(debit - credit) AS difference FROM Vendor_Reconcilation_System.vendor_statement where supplier_code = '${selectedOption}' and division = '${selectedOption1}'and credit = 0 and status = 'Unmatched' and vch_type not in ('Credit Note', 'Debit Note');'`
            };
            fetchFunction = Fetchexecutequery;
            break;
          case 'Annexure6':
            payload = {
              query: `select sum(debit) as debit,sum(credit) as credit, sum(debit - credit) AS difference FROM Vendor_Reconcilation_System.vendor_statement where supplier_code = '${selectedOption}' and division = '${selectedOption1}' and status = 'Unmatched' and debit=0 and vch_type not in ('Credit Note', 'Debit Note');'`
            };
            fetchFunction = Fetchexecutequery;
            break;
          
          case 'Annexure8':
              payload = {
                query: `select sum(debit) as debit,sum(credit) as credit, sum(debit - credit) AS difference FROM Vendor_Reconcilation_System.vendor_statement where supplier_code = '${selectedOption}' and division = '${selectedOption1}' and status = 'Unmatched' and vch_type in ('Credit Note', 'Debit Note');'`
              };
              fetchFunction = Fetchexecutequery;
              break;
          case 'Annexure9':
            payload = {
              query : `SELECT * FROM Vendor_Reconcilation_System.internal_statement WHERE SUPPLIER_CODE = '${selectedOption}' and DIVISION_NAME = '${selectedOption1}' and status ='Contra';`,
             
            };
            fetchFunction = Fetchexecutequery;
            break;
          default:
            payload = {};
        }
  
        // Fetch data for the current tab and store it in allTabData
        const data = await fetchDataAndSetsummaryData(tab,payload, fetchFunction);
        console.log('12345',data);

        allTabData[tab] = data;
      }
  
      // Now allTabData contains the fetched data for all tabs
      console.log('Data for all tabs:', allTabData);
      // You can then assign allTabData to the parameter you want
      // For example: setParameter(allTabData);
    } catch (error) {
      console.error('Error fetching data for all tabs:', error);
    }
  };
  


  const fetchDataForTab = async (tab) => {
    try {
      let payload;
      let description;
      console.log("tabs",tab)

      switch (tab) {
        case 'Annexure 2':
          console.log('case1')
          payload = {
            query : `SELECT GL_DATE,INVOICE_NUMBER,GL_DEBIT,GL_CREDIT FROM Vendor_Reconcilation_System.internal_statement WHERE SUPPLIER_CODE = '${selectedOption}' AND DIVISION_NAME = '${selectedOption1}'  and DOC_CATEGORY ='STD INV' and status = 'Unmatched';`,
          };
          description = 'Purchase Invoices booked by ABS not appearing/accounted by vendor'
            

          await fetchDataAndSetTableData(payload, Fetchexecutequery,description);
          break;
        case 'Annexure 4':
          payload = {
            query : `SELECT GL_DATE,INVOICE_NUMBER,GL_DEBIT,GL_CREDIT,INVOICE_PAYMENT_AMT FROM Vendor_Reconcilation_System.internal_statement WHERE SUPPLIER_CODE = '${selectedOption}' AND DIVISION_NAME = '${selectedOption1}' AND DOC_CATEGORY LIKE '%BV%' AND status = 'Unmatched';`,
          };
          description = 'Payment made by ABS not accounted by vendor'
          await fetchDataAndSetTableData(payload, Fetchexecutequery,description);
          break;     
        case 'Annexure 5':
          payload = {
            query : `SELECT GL_DATE,INVOICE_NUMBER,GL_DEBIT,GL_CREDIT FROM Vendor_Reconcilation_System.internal_statement WHERE SUPPLIER_CODE = '${selectedOption}' AND DIVISION_NAME = '${selectedOption1}' and (DOC_CATEGORY ='CRM INV'OR DOC_CATEGORY LIKE '%TDS%') and status = 'Unmatched';`,
          };
          description = 'TDS dedcuted by ABS not accounted by Supplier'
          await fetchDataAndSetTableData(payload, Fetchexecutequery,description);
          break;

        case 'Annexure 6':
          payload = {
          query : `SELECT GL_DATE,INVOICE_NUMBER,GL_DEBIT,GL_CREDIT FROM Vendor_Reconcilation_System.internal_statement WHERE SUPPLIER_CODE = '${selectedOption}' AND DIVISION_NAME = '${selectedOption1}' AND (DOC_CATEGORY LIKE '%DBM%' OR DOC_CATEGORY LIKE '%DN%') AND status = 'Unmatched';`, 
          };
          description = 'Debit Note raised by ABS not accounted by Supplier'
          await fetchDataAndSetTableData(payload, Fetchexecutequery,description);
          break; 
        case 'Annexure 1':
          payload = {
            query : `SELECT date,\`vch_no.\`,	debit,credit FROM Vendor_Reconcilation_System.vendor_statement WHERE supplier_code = '${selectedOption}' AND division = '${selectedOption1}' and credit = 0 and status = 'Unmatched' and vch_type not in ('Credit Note', 'Debit Note');`, 

          };
          description = 'Sales considered by vendor but not accounted by ABS'
          await fetchDataAndSetTableData(payload, Fetchexecutequery,description);
          break;
        case 'Annexure 3':
          payload = {
            query : `SELECT date,\`vch_no.\`,	debit,credit FROM Vendor_Reconcilation_System.vendor_statement WHERE supplier_code = '${selectedOption}' AND division = '${selectedOption1}' and status = 'Unmatched' and debit=0 and vch_type not in ('Credit Note', 'Debit Note');`, 

          };
          description = 'Payment received by vendor but not accounted by ABS'
          await fetchDataAndSetTableData(payload, Fetchexecutequery,description);
          break;
        
          case 'Annexure 7':
            payload = {
              query: `SELECT 
              CASE 
                  WHEN e.status = 'Match' THEN IFNULL(i.INVOICE_NUMBER, '') 
                                END AS 'invoice_number', 
              DATE_FORMAT(i.GL_DATE, '%d-%m-%y') AS 'gl_date', 
              CASE 
                  WHEN e.status = 'Match' THEN 
                      CASE 
                          WHEN (e.credit - e.debit) >= 0 THEN CONVERT(e.credit - e.debit, DECIMAL(10, 2))
                          ELSE (CONVERT(e.debit - e.credit, DECIMAL(10, 2)) * -1)
                      END 
              END AS 'ven_invoice_amount',
              CASE 
                  WHEN e.status = 'Match' THEN 
                      CASE 
                          WHEN (i.GL_DEBIT - i.GL_CREDIT) >= 0 THEN CONVERT(i.GL_DEBIT - i.GL_CREDIT, DECIMAL(10, 2))
                          ELSE (CONVERT(i.GL_CREDIT - i.GL_DEBIT, DECIMAL(10, 2)) * -1)
                      END 
                         END AS 'invoice_amount',
              ROUND(IFNULL(CONVERT((i.GL_DEBIT - i.GL_CREDIT)-(e.credit - e.debit), DECIMAL(10, 2)), 0.00), 2) AS 'diff_amount' 
          FROM 
              Vendor_Reconcilation_System.internal_statement i 
              INNER JOIN Vendor_Reconcilation_System.vendor_statement e ON i.match_id = e.match_id
          JOIN
              (SELECT match_id, SUM(credit) AS total_credit, SUM(debit) AS total_debit
              FROM Vendor_Reconcilation_System.vendor_statement
              WHERE supplier_code = '${selectedOption}' and division = '${selectedOption1}' AND (status = 'Match')
              GROUP BY match_id) AS v_totals ON i.match_id = v_totals.match_id
          WHERE 
              e.supplier_code = '${selectedOption}' AND e.division = '${selectedOption1}' AND i.DIVISION_NAME = '${selectedOption1}' AND i.SUPPLIER_CODE = '${selectedOption}'
              AND (i.status = 'Match')
          GROUP BY 
              invoice_number
          HAVING 
              diff_amount != '0.00';`
            };
            description = 'Invoices reconciled with value differences'
            await fetchDataAndSetTableData(payload, Fetchexecutequery,description);
            break;
          
          case 'Annexure 8':
              payload = {
                query : `SELECT date,\`vch_no.\`,debit,credit FROM Vendor_Reconcilation_System.vendor_statement WHERE supplier_code = '${selectedOption}' AND division = '${selectedOption1}' and status = 'Unmatched' and vch_type in ('Credit Note', 'Debit Note');`, 
              };
              description = 'Credit Note raised by Vendor not accounted by ABS'
              await fetchDataAndSetTableData(payload, Fetchexecutequery,description);
              break;
        case 'Annexure 9':
          payload = {
            query : `SELECT GL_DATE,INVOICE_NUMBER,	SUPPLIER_INVOICE_NO,SUPPLIER_INVOICE_DATE,GL_DEBIT,GL_CREDIT,INVOICE_PAYMENT_AMT FROM Vendor_Reconcilation_System.internal_statement WHERE SUPPLIER_CODE = '${selectedOption}' AND DIVISION_NAME = '${selectedOption1}' AND DOC_CATEGORY LIKE '%BV%' AND status ='Contra';;`,
            
          };
          description = 'Contra entries as per ABS SOA'
          await fetchDataAndSetTableData(payload, Fetchexecutequery,description);
          break;
        
        default:
          payload = {};
          await fetchDataAndSetTableData(payload, Fetchbankinvoicedetails);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // const fetchDataAndSetTableData = async (payload, fetchFunction) => {
  //   try {
  //     var FileUploadCredentials = fetchFunction();
  //     const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
  //     setTableData(response.data);
  //   } catch (error) {
  //     console.error('Error in POST request:', error);
  //     throw error;
  //   }

  //   let remarkscol = [];

  //   // Check if tableData has elements
  //   if (tableData.length > 0) {
  //     // Get the keys (column names) of the first object in tableData
  //     const columnNames = Object.keys(tableData[0]);

  //     // Create column definitions based on columnNames
  //     remarkscol = columnNames.map((columnName) => ({
  //       headerName: columnName, // Use column name as header
  //       field: columnName, // Use column name as field
  //     }));
  //   }
  // };

  function generateColumnNames (activeTab){
    let creditColumnName, debitColumnName;
    if (activeTab === 'Annexure 2' || activeTab === 'Annexure 9' || activeTab === 'Annexure 5' || activeTab === 'Annexure 6') {
      creditColumnName = 'GL_CREDIT';
      debitColumnName = 'GL_DEBIT';
    } else if (activeTab === 'Annexure 1' || activeTab === 'Annexure 3' || activeTab === 'Annexure8') {
      creditColumnName = 'credit';
      debitColumnName = 'debit';
    } else if (activeTab === 'Annexure 4') {
      creditColumnName = 'debit';
      debitColumnName = 'INVOICE_PAYMENT_AMT';
    } else if (activeTab === 'Annexure 7') {
      creditColumnName = 'ven_invoice_amount';
      debitColumnName = 'invoice_amount';
    }
    calculateTotal(creditColumnName,debitColumnName);
    // calculateTotal();
    return { creditColumnName, debitColumnName };
  };

  // Function to calculate totals dynamically based on the active tab and column names
  function calculateTotal(creditColumnName, debitColumnName){
    let totalCredit = 0;
    let totalDebit = 0;
    let totalbal = 0;
    settotalCredit(totalCredit);
    settotalDebit(totalDebit);
    settotalBal(totalbal);
    // const { tableData } = this.state;
    tableData.forEach(row => {
      
      totalCredit += parseFloat(row[creditColumnName]);
      totalDebit += parseFloat(row[debitColumnName]);
      totalCredit = parseFloat(totalCredit.toFixed(2));
      totalDebit = parseFloat(totalDebit.toFixed(2));
      totalbal = totalDebit-totalCredit 
      totalbal = parseFloat(totalbal.toFixed(2));
      settotalCredit(totalCredit);
      settotalDebit(totalDebit);
      settotalBal(totalbal);

    });
    return { totalCredit, totalDebit };
  };
  // let creditColumnName = 'Credit';
  // let debitColumnName = 'debit';

  // const { activeTab, tableData } = this.state;
  // const { creditColumnName, debitColumnName } = generateColumnNames(activeTab);
  // const { totalCredit} = this.calculateTotal(creditColumnName);
  // const { totalDebit } = this.calculateTotal(debitColumnName);


  function formatNumber(num) {
    return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }


  function getKpiinfo(event) {
    let payload = {
      'supplier_code': selectedOption,
      "client_id": selectedOption1
    };
  
    console.log('payload status', payload);
  
    var getProcessingLayerDataWithStatus = getkpidatarecon();
  
    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(response => {
        console.log("Processing Layer Data With Status with chart data----!!!", response);
        let data = response["data"];
        let arrays = data["Overdue"];
        let arrays1 = data["outstanding_value"];
        let arrays2 = data["total"];
        let annexure1 = data["annexure1total"];
        let annexure2 = data["annexure2total"];
        let annexure3 = data["annexure3total"];
        let annexure4 = data["annexure4total"];
        let annexure5 = data["annexure5total"];
        let annexure6 = data["annexure6total"];
        let annexure7 = data["annexure7total"];
        let annexure8 = data["annexure8total"];
        let annexure9 = data["annexure9total"];
        let intopen = data["intopen"];
        let venopen = data["venopen"];
        let openvariance = data["openvariance"];
        let totalvariance = data["totalvariance"];
        let closingperiod = data["closingperiod"];
  
        // Assuming closingperiod is an array of objects
        let reconperiod = closingperiod.CLOSING_PERIOD[closingperiod.CLOSING_PERIOD.length - 1];
  
        console.log('closingperiod', closingperiod);
  
        let overdue = arrays[0].closing_balance;
if (overdue < 0) {
    overdue = '-'+formatNumber(Math.abs(overdue));
} else if (overdue > 0) {
    overdue = formatNumber(overdue);
} else {
    overdue = '0.00'; // Default value for exactly 0
}



        let outsatnding = arrays1[0].closing_balance;
if (outsatnding < 0) {
    outsatnding = '-'+formatNumber(Math.abs(outsatnding ));
} else if (outsatnding > 0) {
    outsatnding = formatNumber(outsatnding);
} else {
    outsatnding = '0.00'; // Default value for exactly 0
}

  
        let annexure1total = annexure1 ? parseFloat(annexure1.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
	console.log(annexure1total);
	let annexure2total = annexure2 ? parseFloat(annexure2.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure3total = annexure3 ? parseFloat(annexure3.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure4total = annexure4 ? parseFloat(annexure4.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure5total = annexure5 ? parseFloat(annexure5.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure6total = annexure6 ? parseFloat(annexure6.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure7total = annexure7 ? parseFloat(annexure7.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure8total = annexure8 ? parseFloat(annexure8.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let annexure9total = annexure9 ? parseFloat(annexure9.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let intopentotal = intopen ? parseFloat(intopen.opening_balance).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let venopentotal = venopen ? parseFloat(venopen.opening_balance).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let openvariancetotal = openvariance ? parseFloat(openvariance).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        let variancetotal = totalvariance ? parseFloat(totalvariance.difference).toFixed(2) : "0";
        let check = arrays2 - variancetotal;
        variancetotal = totalvariance ? parseFloat(totalvariance.difference).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0";
        console.log('check', check);
        
        setErpBalance(outsatnding);
        setVendorBalance(overdue);
        setVariance(parseFloat(arrays2).toFixed(2));
        setannexure1Balance(annexure1total);
        setannexure2Balance(annexure2total);
        setannexure3Balance(annexure3total);
        setannexure4Balance(annexure4total);
        setannexure5Balance(annexure5total);
        setannexure6Balance(annexure6total);
        setannexure7Balance(annexure7total);
        setannexure8Balance(annexure8total);
        setannexure9Balance(annexure9total);
        setIntopen(intopentotal);
        setVenopen(venopentotal);
        setOpenVariance(openvariancetotal);
        settotalVariance(variancetotal);
        setCheck(parseFloat(check).toFixed(2));
  
        setReconperiod(reconperiod);
  
      })
      .catch(error => {
        console.log("Error in Processing Layer Data WIth Status!!!", error);
      });
  }
  


  const fetchDataAndSetsummaryData = async (tab,payload, fetchFunction) => {
    try {
        
        var FileUploadCredentials = fetchFunction();
        console.log('tab',tab)

        const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
        const tableData = response.data;
        
        // Generate column definitions
        let remarkscol = [];
        let columnDefs = [];

        // Check if tableData has elements
        if (tableData.length > 0) {
            // Get the keys (column names) of the first object in tableData
            const columnNames = Object.keys(tableData[0]);

            // Create column definitions based on columnNames
        //     remarkscol = columnNames.map((columnName) => ({
        //         headerName: columnName, // Use column name as header
        //         field: columnName, // Use column name as field
        //     }));
        // }

        columnDefs = columnNames.map((columnName) => ({
          headerName: columnName, // Use column name as header
          field: columnName, // Use column name as field
          sortable: true, // Enable sorting for all columns
          filter: true, // Enable filtering for all columns
      }));
  }


        return tableData;
    } catch (error) {
        console.error('Error in POST request:', error);
        throw error;
    }
};

  const fetchDataAndSetTableData = async (payload, fetchFunction,description) => {
    try {
        var FileUploadCredentials = fetchFunction();
        console.log("tabs",fetchFunction,payload)
        const response = await axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0]);
        const tableData = response.data;
        
        // Generate column definitions
        let remarkscol = [];
        let columnDefs = [];

        // Check if tableData has elements
        if (tableData.length > 0) {
            // Get the keys (column names) of the first object in tableData
            const columnNames = Object.keys(tableData[0]);

            // Create column definitions based on columnNames
        //     remarkscol = columnNames.map((columnName) => ({
        //         headerName: columnName, // Use column name as header
        //         field: columnName, // Use column name as field
        //     }));
        // }
        setReportremarks(description);
        console.log("description",description)

        columnDefs = columnNames.map((columnName) => ({
          headerName: columnName, // Use column name as header
          field: columnName, // Use column name as field
          sortable: true, // Enable sorting for all columns
          filter: true, // Enable filtering for all columns
      }));
  }
        setTableData(tableData);
        setremarkscol(columnDefs);
        return tableData;
    } catch (error) {
        console.error('Error in POST request:', error);
        throw error;
    }
};


  const handleTabChange = (e, { name }) => {
    setActiveTab(name);
    generateColumnNames(activeTab);
    setReportremarks('');
  };
  useEffect(() => {
    if (activeTab) {
      generateColumnNames(activeTab);
      // if (activeTab === 'Summary') {
      //   getKpiinfo(activeTab);
      //   // fetchDataForAllTabs()
      // } else {
      //   fetchDataForTab(activeTab);
      // }
    }
  });

  

  return (
    <div className="custom-layout">
      <div style={{ paddingLeft: '20px',paddingTop: '10px' }}>
        <Grid>
          <Grid.Row>
            <Grid.Column style={{ width: '15%' }}>
              <div className="form-group-1">
                <label className="label1 mb-1" htmlFor={`relationshipNameInput`} style={{ fontSize: '16px' }}>Vendor Code</label> <br />
                <Select
                  options={options}
                  onChange={handleSelection}
                  value={options.find(opt => opt.value === selectedOption)}
                  styles={{ container: (provided) => ({ ...provided, width: '100%' }),
                            control: (provided) => ({
    		  		...provided,
                                  height: '35px', // Adjust the height as needed
                                  minHeight: '35px', // Ensure minHeight matches height for consistency
                                }), }}
                />
              </div>
            </Grid.Column>

            <Grid.Column style={{ width: '15%' }}>
              <div className="form-group-1">
                <label className="label1 mb-1" htmlFor={`relationshipNameInput`}>Division</label> <br />
                <Select
                  options={division}
                  isClearable
                  onChange={handleSelection1}
                  value={division.find(div => div.value === selectedOption1)}
                  styles={{ container: (provided) => ({ ...provided, width: '100%' }) }}
                />
              </div>
            </Grid.Column>
            <Grid.Column style={{ width: '20%'}}>
              <br></br>
              <div style={{ marginTop: '10px' }}>
                <Button primary style={{ padding: '8px 12px', fontSize: '14px' }} onClick={handleSearchClick}>
                  Search
                </Button>
              </div>
            </Grid.Column>
            <Grid.Column style={{ width: '20%',paddingTop:  '5px' }}>
            <div>
            <br></br>
            
            <a href={link}>
      <img
        src={excelIcon}
        alt="No Images"
        style={{ width: '40px', height: '37px' }}
        className="excel-icon-class"
        title="Export"
      />
    </a>
                    </div>
            
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>

      {showTabs && (
        <div className="content-container" style={{ paddingLeft: '10px' }}>
          
          <Grid columns={2} stackable>
  <Grid.Column width={3}>
    <Menu pointing vertical fluid>
      {tabNames.map((tabName) => (
        <Menu.Item
          key={tabName}
          name={tabName}
          active={activeTab === tabName}
          onClick={handleTabChange}
        >
          {tabName === 'Summary' ? 'Summary' : tabName.charAt(0).toUpperCase() + tabName.slice(1)}
        </Menu.Item>
      ))}
    </Menu>
  </Grid.Column>
  <Grid.Column width={13}>
  <Grid.Row>
    
  </Grid.Row>
  <Grid.Row>
    <div className="ag-theme-balham report-layer" style={{ overflow: 'hidden', width: '95%'}}>
      {activeTab === 'Summary' ? (
        <div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
  {summaryItems.map((item, index) => (
    <div key={index} style={{ borderBottom: '1px solid #ddd', padding: '12px', display: 'flex' }}>
      <div style={{ flex: '65%', textAlign: 'left',width: '50px', marginRight: '10px' }}>{item.description}</div>
      <div style={{  marginRight: '10px' }}>:</div>
      <div style={{ flex: '2', textAlign: 'right' }}>{item.value}</div>
    </div>
  ))}
</div>


        </div>
      ) : (

        <div>
        {/* Display multiple totals above the grid table */}
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          <div style={{ paddingRight: '40px', fontWeight: 'bold', fontSize: '1.2em' }}>{reportremarks}</div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          <div style={{ paddingRight: '10px', fontWeight: 'bold', fontSize: '1.2em' }}>Debit:</div>
          <div style={{ paddingRight: '40px', fontWeight: 'bold', fontSize: '1.2em' }}>{totaldebits}</div>

          <div style={{ paddingRight: '10px', fontWeight: 'bold', fontSize: '1.2em' }}> Credit:</div>
          <div style={{ paddingRight: '40px',fontWeight: 'bold', fontSize: '1.2em' }}>{totalcredits}</div>

          <div style={{ paddingRight: '10px', fontWeight: 'bold', fontSize: '1.2em' }}> Total:</div>
          <div style={{ fontWeight: 'bold', fontSize: '1.2em' }}>{totalbalan}</div>
        </div>
        
        <div className="ag-theme-alpine"
            style={{ width: '100%' }}
          >
        
         <AgGridReact
        animateRows={true}
        rowData={tableData}
        columnDefs={remarkscol.map(column => ({ ...column, width: 150, resizable: true  }))}
        rowHeight={30}
        pagination={true}
        paginationPageSize={10}
        groupSelectsChildren={true}
        enableFilter={true}
        enableSorting={true}
        enableServerSideSorting={true}
        enableServerSideFilter={true}
        suppressRowClickSelection={true}
        suppressAggAtRootLevel={true}
        domLayout='autoHeight'
      >
         </AgGridReact>
      </div>
      </div>
      )}
      
      
    </div>
    </Grid.Row>
  </Grid.Column>
</Grid>

        </div>
      )}
    </div>
  );
};

export default VerticalTabsWithAgGrid;